module.exports = __webpack_public_path__ + "static/media/zola_registry_app_icon@2x.d79c19da.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/footer/zola_registry_app_icon@2x.png
 ** module id = 2140
 ** module chunks = 44
 **/